var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-997.85-288.57H-162.2a3.69,3.69,0,0,1,3.69,3.69V85a0,0,0,0,1,0,0h-843a0,0,0,0,1,0,0V-284.88A3.69,3.69,0,0,1-997.85-288.57Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-717.06,84.11S-524,45.64-442.39-38.52c55.84-57.61,112.55-140.68,221-149.09S28.05-109.89,50.16-25.3c28.91,110.61,9.29,169.53,9.29,169.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.92,42H10.07a5.8,5.8,0,0,1-5.79-5.8l0-22.38A5.79,5.79,0,0,1,10.07,8H22.12l3.73,3.73H39.92a5.8,5.8,0,0,1,5.8,5.8V36.19A5.8,5.8,0,0,1,39.92,42ZM10.07,12.14a1.66,1.66,0,0,0-1.64,1.67l0,22.39a1.67,1.67,0,0,0,1.66,1.66H39.92a1.67,1.67,0,0,0,1.67-1.67V17.54a1.67,1.67,0,0,0-1.67-1.67H24.15l-3.74-3.73Z",
    style: {
      fill: "#636c75"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents_icon.52afcbe824fb9666a0456528c16e9bfd.svg";
export { ForwardRef as ReactComponent };